import { render, staticRenderFns } from "./DateComp.vue?vue&type=template&id=64255d5c&scoped=true&"
import script from "./DateComp.vue?vue&type=script&lang=js&"
export * from "./DateComp.vue?vue&type=script&lang=js&"
import style0 from "./DateComp.vue?vue&type=style&index=0&id=64255d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64255d5c",
  null
  
)

export default component.exports